<div class="toast-wrapper" [ngClass]="getWrapperClasses()" *ngIf="!isClosed">
  <div class="toast-main">
    <div class="toast-icon">
      <mat-icon>{{ getIcon() }}</mat-icon>
    </div>
    <div class="toast-content">
      <div class="toast-title" *ngIf="data.title">{{ data.title }}</div>
      <div class="toast-message" *ngIf="data.message">{{ data.message }}</div>
      <ul class="toast-list" *ngIf="data.messages?.length">
        <li *ngFor="let error of data.messages">{{ error }}</li>
      </ul>
    </div>
    <div class="toast-actions">
      <ng-container *ngIf="data.closeLabel">
        <a
          *ngIf="data.ctaUrl; else plainCta"
          class="toast-pill"
          [href]="data.ctaUrl"
          target="_blank"
          rel="noopener noreferrer"
          (click)="onCtaClick($event, data.ctaUrl)"
        >
          {{ data.closeLabel }}
        </a>
        <ng-template #plainCta>
          <div class="toast-pill">{{ data.closeLabel }}</div>
        </ng-template>
      </ng-container>
      <button class="toast-button" *ngIf="data.dismissible !== false" type="button" (click)="onCloseClick()">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </div>
</div>
